(ns manage.script-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Script")

(spec/def ::name (spec/and string?
                           (complement str/blank?)
                           #(<= (count %) 70)))

(spec/def ::script (spec/and string?
                             (complement str/blank?)))

(spec/def ::value (spec/keys :req-un [::name ::script]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser #(< (count %) 70)
  [_ problem]
  {:message "Name can not be longer than 70 characters"
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.script ::value)))

(def forward-events
  [{:events #{:resource.script/post-success
              :resource.script/put-success}
    :dispatch-to [:form.script/submit-success]}
   {:events #{:resource.script/post-failure
              :resource.script/put-failure}
    :dispatch-to [:form.script/submit-failure]}
   {:events #{:resource.script/delete-success}
    :dispatch-to [:form.script/delete-success]}
   {:events #{:resource.script/delete-failure}
    :dispatch-to [:form.script/delete-failure]}
   {:events #{:resource.script/get-script-success}
    :dispatch-to [:form.script/get-script-success]}
   {:events #{:resource.script/get-script-failure}
    :dispatch-to [:form.script/get-script-failure]}
   {:events #{:modal/close}
    :dispatch-to [:form.script/clean-up-confirmation-state]}])

(form/register-form
 {:namespace :form.script
  :initial-value {:name "" :script ""}
  :validate-form validate-form
  :forward-events forward-events
  :submit-event :form.script/submit-form})

(rf/reg-event-fx :form.script/init-form
  (fn [{:keys [db]} [_ script]]
    (let [dispatch [(when script [:resource.script/get-script (:id script)])
                    [:form.script/init]]]
      (cond-> {:db db}
        script (update-in [:db :form.script] assoc :value script :initial-value script :mode :edit)
        (not script) (assoc-in [:db :form.script :mode] :create)
        true (assoc :dispatch-n (remove nil? dispatch))))))

(rf/reg-event-fx :form.script/submit-form
  [(rf/inject-cofx :sub :form.script/mode)]
  (fn [cofx [_ payload]]
    (let [event (if (= :edit (:form.script/mode cofx))
                  :resource.script/put
                  :resource.script/post)]
      {:dispatch-n [[:loader/open]
                    [event payload]]})))

(rf/reg-event-db :form.script/clean-up-confirmation-state
  (fn [db _]
    (assoc-in db [:form.script :value :confirmation-name] nil)))

(rf/reg-event-fx :form.script/submit-success
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]}]
    {:fx [[:dispatch [:ocp/close]]
          [:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :message "Successfully saved script"
                       :type :success}]]
          [:invalidate-queries {:queryKey ["scripts" (:advertiser-id url-context)]}]]}))

(rf/reg-event-fx :form.script/submit-failure
  (fn [_ [event response]]
    {:dispatch-n [[:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :error
                    :event event
                    :response response}]]}))

(rf/reg-event-fx :form.script/delete
  [(rf/inject-cofx :sub :form.script/allowed-to-delete)]
  (fn [{:keys [db] :as cofx} _]
    (when (:form.script/allowed-to-delete cofx)
      {:dispatch-n [[:loader/open]
                    [:resource.script/delete (get-in db [:form.script :value :id])]]})))

(rf/reg-event-fx :form.script/delete-success
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]}]
    {:fx [[:dispatch [:ocp/close]]
          [:dispatch [:modal/close]]
          [:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :message "Successfully deleted script"
                       :type :success}]]
          [:invalidate-queries {:queryKey ["scripts" (:advertiser-id url-context)]}]]}))

(rf/reg-event-db :form.script/get-script-success
  (fn [db [_ [_ script]]]
    (assoc-in db [:form.script :value :script] script)))

(rf/reg-event-db :form.script/get-script-failure
  (fn [db [_ _script]]
    db))

(rf/reg-event-fx :form.script/delete-failure
  (fn [_ [event response]]
    {:dispatch-n [[:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :error
                    :event event
                    :response response}]]}))

(rf/reg-sub :form.script/allowed-to-delete
  (fn [db _]
    (= (get-in db [:form.script :initial-value :name])
       (get-in db [:form.script :value :confirmation-name]))))

(rf/reg-sub :form.script/mode
  (fn [db]
    (get-in db [:form.script :mode])))

(def use-bind-control (partial form/use-bind-control :form.script))
(def use-error-message (partial form/use-error-message :form.script))
